<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32, xl: 32, xxl: 32 }" class="div-scroll">
  <div *ngFor="let item of data;" nz-col nzSpan="12" [nzXs]="{ span: 24 }" [nzSm]="{ span: 24 }" [nzMd]="{ span: 24 }"
    [nzLg]="{ span: 12 }" [nzXl]="{ span: 12 }" [ngClass]="getClass()">
    <div>
      <div *ngIf="item.lableId !== undefined && item.lableId.length > 0" nz-row>
        <div nz-col nzSpan="3" class="label-id">{{item.lableId}}</div>
        <div nz-col nzSpan="10" class="key">{{item.key | spacedTitleCase}}</div>
      </div>
      <div nz-row>
        <div *ngIf="item.lableId === undefined || item.lableId.length === 0" nz-col nzSpan="12">
          <div class="key">{{item.key | spacedTitleCase}}</div>
        </div>
        <div *ngIf="item.key==='created'; else defaultText" class="value"></div>
      </div>
      <ng-template #defaultText>
        <div *ngIf="item.link !== undefined && item.link.length > 0" nz-col nzSpan="12" class="value">
          <a (click)="onLinkClick(item)">{{item.text}}</a>
        </div>
        <div *ngIf="item.link === undefined" nz-col nzSpan="12" class="value">
          <span *ngIf="item.key?.toLowerCase() === 'riskinforequeststatus' || item.key?.toLowerCase() === 'status'; else checkOutcome" [style.color]="getStatusColor(getStatusLabel(item.text))" [style.font-weight]="'600'">{{getStatusLabel(item.text) | uppercase}}</span>
          <ng-template #checkOutcome>
            <span *ngIf="item.key?.toLowerCase() === 'outcome' || item.key?.toLowerCase() === 'actionRemarks'; else normalText">{{getOutcomeLabel(item.text)}}</span>
            <ng-template #normalText>{{hasDate(item.text)}}</ng-template>
          </ng-template>
        </div>
      </ng-template>
    </div>
  </div>
</div>
